import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';

import { EmblaDots } from '@/components/Carousel/styled';

export const TeamReviewsContainerRow = styled(Row)`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.x9spacePx}px;
  ${media.lgUp`
    padding-bottom: 0;
  `}
`;

export const TeamReviewsHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

export const TeamReviewsContentRow = styled(Row)`
  margin-top: -${({ theme }) => theme.x4spacePx}px;
  ${EmblaDots} {
    bottom: -50px;
  }
`;

export const StyledReactMarkdown = styled('div')`
  color: ${({ theme }) => theme.color.spaceGray};
  padding: 0 ${({ theme }) => theme.x4spacePx}px;
  h3 {
    color: #fff;
    font-size: 120px;
    -webkit-text-stroke: 1px #e75d75;
    font-family: 'Helvetica';
  }
  p {
    ${({ theme }) => theme.typography.base};
    margin-top: -${({ theme }) => theme.x12spacePx}px;
  }
  ${media.lgOnly`
    min-height: 450px;
  `};
  ${media.xlUp`
    min-height: 400px;
  `};
`;

export const ImageContainer = styled.div`
  color: ${({ theme }) => theme.color.spaceGray};
  padding: 0 ${({ theme }) => theme.x4spacePx}px;
  strong {
    display: block;
    ${({ theme }) => theme.typography.large};
    font-weight: 500;
    padding-top: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const ImageContainerMobile = styled(ImageContainer)`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  padding-top: ${({ theme }) => theme.x2spacePx}px;
  div {
    padding-left: 5px;
  }
  strong {
    padding-top: 0px;
  }
  img {
    width: 48px;
    height: 48px;
  }
`;
